import * as rfps from './../../api/rfps/rfp.service';

import * as moment from 'moment';

/**
 * This was moved out of the old JavaScript section and into the TypeScript section and the huge string concatenation
 * for the template was removed in favor of a section with back-ticks. Other than that it hasn't really changed.
 *
 * It should though. For one thing it should start using Flexbox for layout and dump the floats. Second would be to dump
 * all the IDs used in the CSS styling. That's entirely my own fault though. I don't know what I was thinking there.
 */
export default function SpendDatesAndOfferTypeDirective() {
  return {
    scope: {
      data: '=spendDatesAndOfferType',
      showTimeline: '='
    },
    link: function (scope: any) {
      let dateFormat = 'MM/DD/YY';

      // Note: You'll see lots of "this.data.something || this.data.some.other.thing" below. That's because some pages
      // are passing in the old RFP data structure and some the new one and they store the same things in different
      // places.

      scope.getData = (): rfps.Rfp => {
        return scope.data || {};
      };

      scope.getSendDateTimestamp = () => {
        // support RFP API v1 and v2
        let { sendDate, submissionDate } = scope.getData();
        return sendDate || submissionDate;
      };

      scope.getId = () => {
        // support RFP API v1 and v2
        let { requestId, id } = scope.getData();
        return requestId || id;
      };

      scope.startDate = function () {
        let sendDateTimeStamp = scope.getSendDateTimestamp();

        if (sendDateTimeStamp) {
          return moment(sendDateTimeStamp)
            .subtract(14, 'months')
            .startOf('month')
            .format(dateFormat);
        } else {
          return moment()
            .subtract(14, 'months')
            .startOf('month')
            .format(dateFormat);
        }
      };

      scope.endDate = function () {
        let sendDateTimeStamp = scope.getSendDateTimestamp();

        if (sendDateTimeStamp) {
          return moment(sendDateTimeStamp)
            .subtract(3, 'months')
            .endOf('month')
            .format(dateFormat);
        } else {
          return moment()
            .subtract(3, 'months')
            .endOf('month')
            .format(dateFormat);
        }
      };

      // This function is used both to display the date the RFP was sent and as a canary to turn off display of the
      // upper section when there are no dates to display.
      scope.sentDate = function () {
        let sendDateTimeStamp = scope.getSendDateTimestamp();
        let date;
        let valueToDisplay: string = '';

        if (sendDateTimeStamp) {
          date = moment(sendDateTimeStamp);

          // If the send date is in the future (that is, it's a scheduled RFP) then we treat this the same as if
          // there is no send date at all.
          if (!date.isAfter(moment())) {
            valueToDisplay = date.format(dateFormat);
          }
        }

        return valueToDisplay;
      };

      scope.type = function () {
        // support RFP API v1 and v2
        let { rfpType, type } = scope.getData();
        return rfpType || type;
      };

      scope.email = function () {
        // support RFP API v1 and v2
        let {
          requestedBy = {} as rfps.RequestedBy,
          submittedBy = {} as rfps.SubmittedBy
        } = scope.getData();
        let { email } = requestedBy;
        let { emailAddress } = submittedBy;

        return email || emailAddress;
      };
    },
    template: `<div style="position: relative;">
                 <div id="spendDatesAndOfferTypeControl">
                   Request Details
                   <div id="spendDatesInformation" ng-if="!showTimeline">
                     <div id="dateInfo" ng-if="startDate()">
                       Spend dates: {{ startDate() }} - {{ endDate() }}
                     </div>
                     <div id="typeInfo">
                       <div>
                         <span ng-if="type() == 'RFP'">Request for Pricing (RFP): ID {{ getId() }}</span>
                         <span ng-if="type() == 'SIO'">Seller Initiated Offer (SIO): ID {{ getId() }}</span>
                       </div>
                   </div>
                 </div>
                 <div id="spendDatesInformation" class="spendDatesInformationWithTimeline" ng-if="showTimeline"><div class="content">
                   <div style="float: left; width: 50%; height: 50px; background-color: #f2f2f2;">
                     <div id="typeInfo">
                       <div>
                         <span ng-if="type() == 'RFP'">Request for Pricing (RFP): ID {{ getId() }}</span>
                         <span ng-if="type() == 'SIO'">Seller Initiated Offer (SIO): ID {{ getId() }}</span>
                       </div>
                     </div>
                     <div id="sentInfo" ng-if="sentDate()">
                       From:&nbsp;<a ng-href="mailto:{{ email() }}" title="{{ email() }}">{{ email() }}</a><br>
                     </div>
                   </div>
                   <div style="float: left; width: 50%; height: 50px; background-color: #f2f2f2;">
                     <div id="dateInfo" ng-if="startDate()">
                       Spend dates: {{ startDate() }} - {{ endDate() }}
                     </div>
                     <div id="sentInfo" ng-if="sentDate()">
                       Sent on: {{ sentDate() }}
                     </div>
                   </div>
                   <div ng-if="showTimeline"><div data-timeline-component="" data-requestid="getId()" data-buyer="true"></div></div>
                 </div>
               </div>`
  };
}
